/* eslint-disable import/no-cycle */
import React from "react";

import { useHistory } from "react-router-dom";

import { Dialog } from "primereact";

import { FilterModel } from "../../../../../domain/models/enum";
import {
  TakerModel,
  TakerResponseModel,
} from "../../../../../domain/models/taker";
import { UserProps } from "../../../../../domain/models/user";

import { makeRemoteTaker } from "../../../../../main/factories/usecases/taker/remote-taker-factory";

import toastUtils from "../../../../../utils/ToastUtils";
import LocalStorage from "../../../../../infra/localStorage";

import ButtonComponent from "../../../../components/button";
import DataGrid from "../../../../components/datagrid";
import FormFactory from "../../../../components/form-factory";
import {
  fieldsGrid,
  FieldsTomador,
  FilterFields,
} from "../../invoice/form/fields";
import ChooseModal from "../../../../components/modals/choose-modal";

import { theme } from "../../../../styles/theme";
import { CustomGrid } from "../../invoice/form/styles";
import { FormFactoryContainer } from "./styles";

type PageProps = {
  setCurrentNote: (prev: any) => void;
  currentNote: any;
};

const generateFilter = (values: any): string =>
  Object.keys(values)
    .filter((el) => !!values[el])
    .map((el) => {
      if (el === "developer") {
        return `${el}=${values[el]}`;
      }

      return el;
    })
    .join(",");

const isSmallScreen = window.innerWidth < 768;

const TomadorComponent: React.FC<PageProps> = ({
  setCurrentNote,
  currentNote,
}) => {
  const history = useHistory();

  const [confirm, setConfirm] = React.useState<TakerModel | null>();
  const [takerCreatedOpUpdated, setTakerCreatedOrUpdated] =
    React.useState<TakerModel | null>();
  const [selected, setSelected] = React.useState<TakerModel | null>();
  const [list, setList] = React.useState<TakerResponseModel>();
  const [loading, setLoading] = React.useState<boolean>();
  const [show, setShow] = React.useState<boolean>();
  const [showGrid, setShowGrid] = React.useState<boolean>();
  const [params, setParams] = React.useState<FilterModel>({});

  React.useEffect(() => {
    (async () => {
      const userParams: UserProps = LocalStorage.get("user");
      setLoading(true);
      const takerList = await makeRemoteTaker().load({
        ...params,
        filters: generateFilter({
          ...params?.filters,
          developer: userParams.developerResponseDTO.id,
        }),
      });
      setList(takerList);
      setLoading(false);
    })();
  }, [params, takerCreatedOpUpdated]);

  const onHide = (): void => {
    setShow(false);
  };

  const handlePage = (e: any): void => {
    setParams((prev: FilterModel) => ({
      ...prev,
      page: e,
    }));
  };

  const handleSubmit = async (values: any, actions: any): Promise<void> => {
    try {
      const userParams: UserProps = LocalStorage.get("user");
      actions.setSubmitting(true);
      if (selected?.id) {
        const takerData = await makeRemoteTaker().update(selected?.id, {
          address: {
            id: selected?.address?.id,
            place: values?.address,
            number: values?.number,
            district: values?.district,
            city: values?.city,
            state: values?.state,
            complement: values?.complement,
            zipCode: values?.zipCode,
          },
          id: selected?.id,
          documentNumber: values.documentNumber,
          documentTypeEnum: values.documentTypeEnum,
          email: values?.email,
          municipalRegistration: values?.municipalRegistration || "",
          socialReason: values?.socialReason,
          stateRegistration: values?.stateRegistration,
          taxSubstitute: values?.taxSubstitute === "true",
        });
        setConfirm(takerData);
        setTakerCreatedOrUpdated(takerData);
      } else {
        const takerData = await makeRemoteTaker().create({
          address: {
            place: values?.address,
            number: values?.number,
            district: values?.district,
            city: values?.city,
            state: values?.state,
            complement: values?.complement,
            zipCode: values?.zipCode,
          },
          documentNumber: values.documentNumber,
          documentTypeEnum: values.documentTypeEnum,
          email: values?.email,
          municipalRegistration: values?.municipalRegistration || "",
          socialReason: values?.socialReason,
          stateRegistration: values?.stateRegistration,
          taxSubstitute: values?.taxSubstitute === "true",
          developerId: userParams.developerResponseDTO.id,
        });
        setConfirm(takerData);
        setTakerCreatedOrUpdated(takerData);
      }
      toastUtils.showMessage({
        type: "success",
        message: "Salvo com Sucesso",
      });
      actions.setSubmitting(false);
    } catch (error: any) {
      actions.setSubmitting(false);
      toastUtils.showMessage({
        type: "error",
        message: `Erro ao salvar informações:${
          error?.detail || error?.userMessage
        }`,
      });
    }
  };

  return (
    <div className="w-50 d-flex justify-content-center mb-4 taker-container">
      <div className="w-50">
        <ButtonComponent
          type="button"
          title={
            currentNote?.taker?.socialReason
              ? currentNote?.taker?.socialReason
              : "Selecionar Tomador"
          }
          color={theme.colors.white}
          backgroundColor={theme.colors.primary}
          onClick={() => setShowGrid(true)}
        />
      </div>
      <div className="ms-2 w-50">
        <ButtonComponent
          type="button"
          title="+ Novo Tomador"
          color={theme.colors.blue100}
          backgroundColor={theme.colors.darkBlue}
          onClick={() => setShow(true)}
          border
        />
      </div>
      <Dialog
        header="Adicionar Tomador:"
        visible={!!show}
        style={{ width: isSmallScreen ? "90vw" : "70vw" }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
        }}
        footer={null}
        onHide={() => onHide()}
      >
        <FormFactoryContainer>
          <FormFactory
            groups={FieldsTomador(selected)}
            enbaleCountGroup
            onSubmit={async (values, actions) => {
              try {
                await handleSubmit(values, actions);
                actions.setSubmitting(false);
              } catch (error) {
                actions.setSubmitting(false);
              }
            }}
            button={{
              submit: "Incluir Dados de tomador na Nota",
              submitting: "Incluindo...",
              hide: false,
              backgroundColor: theme.colors.blue400,
            }}
          />
        </FormFactoryContainer>
      </Dialog>
      <Dialog
        header="Selecionar Tomador: "
        visible={!!showGrid}
        style={{ width: isSmallScreen ? "90vw" : "70vw" }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
        }}
        footer={null}
        onHide={() => setShowGrid(false)}
      >
        <FormFactory
          groups={FilterFields(setParams)}
          enbaleCountGroup
          onSubmit={async (values, actions) => {
            try {
              console.warn(values, actions);
              actions.setSubmitting(false);
            } catch (error) {
              actions.setSubmitting(false);
            }
          }}
          backButton={{
            submit: "Voltar",
            submitting: "Voltando...",
            hide: true,
            onClick: () => history.goBack(),
          }}
          button={{
            submit: "Incluir Dados de tomador na Nota",
            submitting: "Incluindo...",
            hide: true,
            backgroundColor: theme.colors.darkBlue,
          }}
        />
        <CustomGrid>
          <div className="title-grid">Tomadores:</div>
          <DataGrid
            loading={!!loading}
            fields={fieldsGrid(setShow, setShowGrid, setSelected)}
            data={list?.content || []}
            onClickRow={(callback: TakerModel) => {
              setConfirm(callback);
            }}
            totalPages={list?.totalPages || 0}
            changePage={handlePage}
          />
        </CustomGrid>
      </Dialog>
      <ChooseModal
        text={`${confirm?.socialReason} é o seu tomador?`}
        onConfirm={async () => {
          setShowGrid(false);
          setShow(false);
          setCurrentNote((prev: any) => ({ ...prev, taker: confirm }));
          toastUtils.showMessage({
            type: "success",
            message: "Selecionado com Sucesso!",
          });
          setConfirm(null);
        }}
        onCancel={() => setConfirm(null)}
        isVisible={!!confirm}
        toggleVisibility={() => setConfirm(null)}
      />
    </div>
  );
};

export default TomadorComponent;
